import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderUploadStatus = () => (
    <header className="HeaderUploadStatus" role="banner">
        <nav
            className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar"
            aria-label="Upload status header bar with admin navigation"
        >
            <div className="container w-max2">
                <h5 className="sp-mx" id="uploadstatus-header-title">
                    <i className="bi bi-file-bar-graph" aria-hidden="true"></i>
                    <span className="sp-margin12 v-set4">Upload Status</span>
                </h5>
                <NavAdmin />
            </div>
        </nav>
  </header>
);

export default HeaderUploadStatus;
